module.exports = __webpack_public_path__ + "static/img/13.c0264c6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/8/1/zh/13.png
// module id = deOF
// module chunks = 0